///---------------------------------------------------------------------------
//! Copyright (C) ASQUARED SRL - All Rights Reserved
//* Unauthorized copying of this file, via any medium is strictly prohibited
//* Proprietary and confidential
//* Written by Alexandru Gârbacea <g99.alex@yahoo.com>, September 2022
//? @author g99.alex@yahoo.com
///---------------------------------------------------------------------------

import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import NTPLogo from 'ntp-logo-react';

import { COMPANY, 
    // PHONE_PUBLIC, 
    // fullAddress 
} from '../services/CompanyService';

//-----------------------------------------------------------------------------------------
//* \brief
//? Background colour the NETOPIA logo sits on.
//?
//? Its `color` prop is NOT the logo colour - it is the colour of the surface behind it,
//? from which the component works out whether to draw itself in black or white. The footer
//? is --contrast-body-color, which is white in the light theme and dark blue in the dark
//? one, so passing a fixed value would make the logo invisible in one of them.
//-----------------------------------------------------------------------------------------
const readFooterBackground = () => {
    if (typeof window === 'undefined') return '#ffffff'
    const value = getComputedStyle(document.documentElement)
        .getPropertyValue('--contrast-body-color').trim()
    return value || '#ffffff'
}

const Footer = () => {

    const getYear = () => {
        const year = new Date().getFullYear();
        return year;
    }

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    const [footerBackground, setFooterBackground] = useState(readFooterBackground)

    //? The theme is switched by setting an attribute on <html>, so watch that rather than
    //? asking the Header to tell us - the logo has to recolour with it.
    useEffect(() => {
        setFooterBackground(readFooterBackground())
        const observer = new MutationObserver(() => setFooterBackground(readFooterBackground()))
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['display-theme']
        })
        return () => observer.disconnect()
    }, [])

  return (
    <div className='footer-wrapper'>
    <div className='footer'>
        <ul className='list-block'>
            <Link to={'/'} className='link'>Meniu</Link>
        </ul>
        <ul className='list-block'>
            <Link className='link' to={'/termeni-si-conditii'} onClick={scrollToTop}>Termeni și condiții</Link>
            <Link className='link' to={'/politica-de-confidentialitate'} onClick={scrollToTop}>Politica de confidențialitate</Link>
            {/* Linked twice, by name: each policy has to be findable under the exact wording
                a card processor's site review looks for */}
            <Link className='link' to={'/politica-livrare-anulare#livrare'} onClick={scrollToTop}>Politica de livrare</Link>
            <Link className='link' to={'/politica-livrare-anulare#anulare'} onClick={scrollToTop}>Politica de anulare</Link>
            <div className='link' id="setari-cookies">Setări Cookies</div>
        </ul>
        <ul className='list-block'>
            <Link className='link' to={'/contact'} onClick={scrollToTop}>Contact</Link>
            <Link className='link' to={'/info'} onClick={scrollToTop}>Informații</Link>
            <Link className='link' to={'/docs'} onClick={scrollToTop}>Documentație</Link>
            <Link className='link' to={'/verificare-xml-intrastat'} onClick={scrollToTop}>Verificare fișier XML</Link>
        </ul>
    </div>

    {/* Company identification - has to be visible, not only inside a legal document */}
    {/* <div className='footer-company'>
        <span><b>{COMPANY.name}</b> · CUI {COMPANY.cui} · Reg. Com. {COMPANY.regCom}</span>
        <span>{fullAddress()}</span>
        <span>
            {COMPANY.email}
            {PHONE_PUBLIC && <> · {COMPANY.phone}</>}
        </span>
    </div> */}

    {/* One row: consumer dispute resolution on the left, payment processor on the right.
        The banners are served from public/images rather than hotlinked from someone else's
        site - these are a compliance requirement, and a third party deleting a file would
        silently remove them. */}
    <div className='footer-bottom-bar'>
        <div className='footer-anpc'>
            <a href='https://anpc.ro/ce-este-sal/'
                target='_blank' rel='noopener noreferrer nofollow'>
                <img className='footer-anpc__img'
                    src='/images/anpc-sal.png'
                    width='500' height='124'
                    loading='lazy'
                    alt='ANPC — Soluționarea Alternativă a Litigiilor' />
            </a>
            <a href='https://ec.europa.eu/consumers/odr'
                target='_blank' rel='noopener noreferrer nofollow'>
                <img className='footer-anpc__img'
                    src='/images/anpc-sol.png'
                    width='500' height='124'
                    loading='lazy'
                    alt='Soluționarea Online a Litigiilor' />
            </a>
        </div>

        <a className='footer-netopia'
            href='https://netopia-payments.com'
            target='_blank' rel='noopener noreferrer nofollow'
            aria-label='Plăți procesate de NETOPIA Payments'>
            <NTPLogo color={footerBackground} version="horizontal" secret="168057" />
        </a>
    </div>

    <p className='copyright'>© Copyright {getYear()} {COMPANY.name} Toate drepturile rezervate.</p>
    </div>
  )
}

export default Footer
